import RoomCabinetList from './RoomCabinetList';
export default RoomCabinetList;
